import qs from 'qs'

/**
 * The email carried on an auth-page link, e.g. the "client portal access enabled" welcome
 * email, which opens /signup?email=<url-encoded email>. Returns '' when there is none, so it
 * can go straight into a form's defaultValues.
 */
export const getEmailFromSearch = (search = '') => {
	const { email } = qs.parse(String(search).replace(/^\?/, ''))
	return typeof email === 'string' ? email.trim() : ''
}

export default getEmailFromSearch
